<template>
  <div class="print-small-container">

      <div class="print_container" :class="'paper-' + paperType">
        <!-- 票头 -->
        <div class="receipt-shop">{{ printSmallPayFeeInfo.communityName }}</div>
        <div class="receipt-title">{{ $t('printSmallPayFee.receipt') }}</div>
        <div class="divider"></div>

        <!-- 基本信息 -->
        <div class="info-list">
          <div class="info-row">
            <span class="info-label">{{ $t('printSmallPayFee.receiptNum') }}:</span>
            <span class="info-value">{{ printSmallPayFeeInfo.receiptNum }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('printSmallPayFee.orderNum') }}:</span>
            <span class="info-value">{{ printSmallPayFeeInfo.payOrderId }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('printSmallPayFee.roomNum') }}:</span>
            <span class="info-value">{{ printSmallPayFeeInfo.roomName }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('printSmallPayFee.owner') }}:</span>
            <span class="info-value">{{ printSmallPayFeeInfo.payObjName }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('printSmallPayFee.time') }}:</span>
            <span class="info-value">{{ formatDate(printSmallPayFeeInfo.feeTime) }}</span>
          </div>
        </div>
        <div class="divider"></div>

        <!-- 费用明细 -->
        <div class="fee-item" v-for="(item, index) in printSmallPayFeeInfo.fees" :key="index">
          <div class="fee-item-head">
            <span class="fee-name">{{ item.feeName }}</span>
            <span class="fee-amount">{{ formatAmount(item.amount) }}</span>
          </div>
          <div class="fee-item-body">
            <div>{{ $t('printSmallPayFee.feeRange') }}: {{ formatDate(item.startTime) }} {{ $t('printSmallPayFee.to') }} {{ formatDate(item.endTime) }}</div>
            <div>{{ $t('printSmallPayFee.unitPrice') }}: {{ item.squarePrice }}</div>
            <div>{{ $t('printSmallPayFee.areaUsage') }}: {{ item.area }}</div>
            <div v-if="item.preDegrees">{{ $t('printSmallPayFee.meterReading') }}: {{ item.preDegrees }} {{ $t('printSmallPayFee.to') }} {{ item.curDegrees }}</div>
            <div v-if="item.discountPrice">{{ $t('printSmallPayFee.discount') }}: {{ item.discountPrice }}</div>
            <div v-if="item.remark">{{ $t('printSmallPayFee.remark') }}: {{ item.remark }}</div>
          </div>
        </div>
        <div class="divider"></div>

        <!-- 合计 -->
        <div class="total-row">
          <span>{{ $t('printSmallPayFee.total') }}:</span>
          <span class="total-amount">¥{{ printSmallPayFeeInfo.amount }}</span>
        </div>
        <div class="total-capital">{{ $t('printSmallPayFee.capital') }}: {{ changeNumMoneyToChinese(printSmallPayFeeInfo.amount) }}</div>
        <div class="pay-method-row">{{ $t('printSmallPayFee.paymentMethod') }}: {{ paymentMethod }}</div>
        <div class="divider"></div>

        <!-- 票尾 -->
        <div class="info-list">
          <div class="info-row">
            <span class="info-label">{{ $t('printSmallPayFee.issuer') }}:</span>
            <span class="info-value">{{ userInfo.name }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('printSmallPayFee.printTime') }}:</span>
            <span class="info-value">{{ printSmallPayFeeInfo.printTime }}</span>
          </div>
        </div>
      </div>

      <div class="paper-selector">
        <span class="paper-label">纸张类型：</span>
        <el-radio-group v-model="paperType" size="small">
          <el-radio-button label="t58">58mm热敏</el-radio-button>
          <el-radio-button label="t80">80mm热敏</el-radio-button>
          <el-radio-button label="d76">76mm针式</el-radio-button>
        </el-radio-group>
      </div>

      <div id="print-btn" class="action-buttons">
        <el-button type="primary" class="float-right" @click="handlePrint">
          <i class="el-icon-printer"></i>&nbsp;{{ $t('printSmallPayFee.print') }}
        </el-button>
        <el-button class="float-right margin-right" @click="handleCloudPrint">
          <i class="el-icon-cloudy"></i>&nbsp;{{ $t('printSmallPayFee.cloudPrint') }}
        </el-button>
        <el-button class="float-right margin-right" @click="handleClose">
          <span>{{ $t('printSmallPayFee.cancel') }}</span>
        </el-button>
      </div>


    <el-dialog :title="$t('printSmallPayFee.cloudPrint')" :visible.sync="cloudPrintVisible" width="50%">
      <div class="cloud-print-content">
        <el-form label-width="120px">
          <el-form-item :label="$t('printSmallPayFee.printer')">
            <el-select v-model="printSmallPayFeeInfo.machineId" style="width:100%"
              :placeholder="$t('printSmallPayFee.printerRequired')">
              <el-option v-for="(item, index) in printSmallPayFeeInfo.machines" :key="index"
                :label="`${item.machineName}(${item.machineCode})`" :value="item.machineId" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('printSmallPayFee.quantity')">
            <el-input v-model="printSmallPayFeeInfo.quantity" type="number"
              :placeholder="$t('printSmallPayFee.quantityRequired')" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('printSmallPayFee.cancel') }}</el-button>
        <el-button type="primary" @click="handleSubmitCloudPrint">{{ $t('printSmallPayFee.submit') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryFeeReceipt,
  queryFeeReceiptDetail,
  listMachinePrinter,
  printPayFeeDetail
} from '@/api/fee/printSmallPayFeeApi'
import { getCommunityId } from '@/api/community/communityApi'
import { getUserId,getUserName } from '@/api/user/userApi'
import { dateFormat as formatDateUtil, getDateStr } from '@/utils/dateUtil'
import { changeNumMoneyToChinese } from '@/utils/moneyUtil'

export default {
  name: 'PrintSmallPayFeeList',
  data() {
    return {
      printSmallPayFeeInfo: {
        communityName: '',
        receiptId: '',
        receiptIds: '',
        receiptNum: '',
        payOrderId: '',
        roomName: '',
        amount: 0.00,
        fees: [],
        feeTime: '',
        wechatName: '',
        payObjName: '',
        machineId: '',
        quantity: '1',
        machines: [],
        printTime: ''
      },
      cloudPrintVisible: false,
      userInfo: {},
      paperType: localStorage.getItem('smallReceiptPaperType') || 't58'
    }
  },
  watch: {
    paperType(val) {
      localStorage.setItem('smallReceiptPaperType', val)
      this.applyPageStyle()
    }
  },
  computed: {
    // 支付方式：整张小票只显示一次，取各费用明细支付方式去重合并（可能存在账户抵扣+现金组合）
    paymentMethod() {
      const methods = []
      ;(this.printSmallPayFeeInfo.fees || []).forEach(item => {
        if (item.primeRate && methods.indexOf(item.primeRate) < 0) {
          methods.push(item.primeRate)
        }
      })
      return methods.length > 0 ? methods.join('/') : '-'
    }
  },
  created() {
    this.printSmallPayFeeInfo.receiptId = this.$route.query.receiptId
    this.printSmallPayFeeInfo.receiptIds = this.$route.query.receiptIds
    this.printSmallPayFeeInfo.communityName = getCommunityId().name
    this.printSmallPayFeeInfo.printTime = getDateStr()
    this.applyPageStyle()
    this.loadData()
    this.userInfo = {
      userId: getUserId(),
      name: getUserName()
    }
  },
  methods: {
    async loadData() {
      await this.loadReceipt()
      await this.loadReceiptDetail()
    },
    async loadReceipt() {
      try {
        const params = {
          page: 1,
          row: 30,
          receiptId: this.printSmallPayFeeInfo.receiptId,
          receiptIds: this.printSmallPayFeeInfo.receiptIds,
          communityId: getCommunityId()
        }
        const { data } = await queryFeeReceipt(params)
        const _feeReceipt = data
        let _amount = 0
        _feeReceipt.forEach(item => {
          _amount += parseFloat(item.amount)
        })
        this.printSmallPayFeeInfo.amount = _amount.toFixed(2)
        this.printSmallPayFeeInfo.roomName = _feeReceipt[0].objName
        this.printSmallPayFeeInfo.feeTime = _feeReceipt[0].createTime
        this.printSmallPayFeeInfo.payObjName = _feeReceipt[0].payObjName
        this.printSmallPayFeeInfo.receiptNum = _feeReceipt[0].receiptCode
      } catch (error) {
        console.error('Failed to load receipt:', error)
      }
    },
    async loadReceiptDetail() {
      try {
        const params = {
          page: 1,
          row: 100,
          receiptId: this.printSmallPayFeeInfo.receiptId,
          receiptIds: this.printSmallPayFeeInfo.receiptIds,
          communityId: getCommunityId(),
          orderBy: 'start_time'
        }
        const { data } = await queryFeeReceiptDetail(params)
        this.printSmallPayFeeInfo.payOrderId = data[0].payOrderId
        this.printSmallPayFeeInfo.fees = data
      } catch (error) {
        console.error('Failed to load receipt detail:', error)
      }
    },
    applyPageStyle() {
      const margins = {
        t58: 'margin: 0;',
        t80: 'margin: 0;',
        d76: 'margin: 5mm;'
      }
      let styleEl = document.getElementById('small-receipt-page-style')
      if (!styleEl) {
        styleEl = document.createElement('style')
        styleEl.id = 'small-receipt-page-style'
        document.head.appendChild(styleEl)
      }
      styleEl.textContent = '@media print { @page { ' + (margins[this.paperType] || 'margin: 0;') + ' } }'
    },
    formatDate(date) {
      if (!date) return ''
      return formatDateUtil(date)
    },
    formatAmount(amount) {
      if (amount < 0) {
        return amount + this.$t('printSmallPayFee.refund')
      }
      return amount
    },
    changeNumMoneyToChinese,
    handlePrint() {
      // 打印前刷新时间，确保与实际打印时刻一致
      this.printSmallPayFeeInfo.printTime = getDateStr()
      this.$nextTick(() => {
        window.print()
      })
    },
    handleCloudPrint() {
      this.listMachinePrinter()
      this.cloudPrintVisible = true
    },
    async listMachinePrinter() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: getCommunityId()
        }
        const { data } = await listMachinePrinter(params)
        this.printSmallPayFeeInfo.machines = data
        if (this.printSmallPayFeeInfo.machines && this.printSmallPayFeeInfo.machines.length > 0) {
          this.printSmallPayFeeInfo.machineId = this.printSmallPayFeeInfo.machines[0].machineId
        }
      } catch (error) {
        console.error('Failed to list machine printer:', error)
      }
    },
    async handleSubmitCloudPrint() {
      try {
        const detailIds = this.printSmallPayFeeInfo.fees.map(item => item.detailId)
        if (detailIds.length < 1) {
          this.$message.error(this.$t('printSmallPayFee.noFee'))
          return
        }
        const data = {
          communityId: getCommunityId(),
          machineId: this.printSmallPayFeeInfo.machineId,
          quantity: this.printSmallPayFeeInfo.quantity,
          detailId: detailIds.join(',')
        }
        const {code,msg} = await printPayFeeDetail(data)
        if (code != 0) {
          this.$message.error(msg)
          return;
        }
        this.cloudPrintVisible = false
        this.$message.success(this.$t('common.operationSuccess'))
      } catch (error) {
        console.error('Failed to submit cloud print:', error)
        this.$message.error(error.message || this.$t('printSmallPayFee.submitFailed'))
      }
    },
    handleClose() {
      window.close()
    }
  }
}
</script>

<style scoped>
.print-small-container {
  padding: 20px;
}

.print_container {
  --title-size: 12pt;
  --body-size: 8pt;
  --small-size: 7pt;
  --amount-size: 10pt;
  width: 48mm;
  margin: 0 auto;
  background: #fff;
  color: #000;
  font-family: 'Microsoft YaHei', 'SimHei', sans-serif;
  font-size: var(--body-size);
  line-height: 1.5;
}

/* 80mm 热敏纸 */
.print_container.paper-t80 {
  --title-size: 16pt;
  --body-size: 10.5pt;
  --small-size: 9pt;
  --amount-size: 13pt;
  width: 72mm;
}

/* 76mm 针式纸：pt 物理单位 + 宋体 + 加粗（双重描绘），避免点阵丢失造成笔画空点 */
.print_container.paper-d76 {
  --title-size: 15pt;
  --body-size: 10pt;
  --small-size: 9pt;
  --amount-size: 13pt;
  width: 66mm;
  font-family: 'SimSun', '宋体', serif;
  font-weight: bold;
}

.receipt-shop {
  text-align: center;
  font-size: var(--small-size);
  margin-bottom: 2pt;
}

.receipt-title {
  text-align: center;
  font-size: var(--title-size);
  font-weight: bold;
  margin-bottom: 2pt;
}

.divider {
  border-top: 1px dashed #000;
  margin: 4pt 0;
}

/* 针式打印虚线易断针，改实线 */
.paper-d76 .divider {
  border-top-style: solid;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.info-row .info-label {
  flex-shrink: 0;
}

.info-row .info-value {
  text-align: right;
  word-break: break-all;
}

.fee-item {
  margin-bottom: 4pt;
  page-break-inside: avoid;
}

.fee-item-head {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  margin: 2pt 0;
}

.fee-item-head .fee-amount {
  flex-shrink: 0;
}

.fee-item-body {
  font-size: var(--small-size);
  line-height: 1.4;
  word-break: break-all;
}

.total-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: var(--amount-size);
  font-weight: bold;
}

.total-capital {
  font-size: var(--small-size);
  word-break: break-all;
}

.pay-method-row {
  font-size: var(--small-size);
  word-break: break-all;
}

.paper-selector {
  margin-top: 20px;
  text-align: center;
}

.paper-selector .paper-label {
  font-size: 14px;
  margin-right: 8px;
}

.action-buttons {
  margin-top: 20px;
  text-align: right;
}

.float-right {
  float: right;
}

.margin-right {
  margin-right: 10px;
}

.cloud-print-content {
  padding: 20px;
}

/* 打印样式：宽度由所选纸型控制，隐藏操作按钮 */
@media print {
  .print-small-container {
    padding: 0;
  }

  .paper-selector,
  #print-btn,
  .action-buttons {
    display: none !important;
  }

  body {
    background: #fff;
  }
}
</style>
